module.exports = __webpack_public_path__ + "img/yado.e86c303e.jpg";